<template>
    <section>
        <section class="section">
            <div class="label mat-30">
                <div class="label-title">是否索要行政收据</div>
                <div class="radio-group clearfix">
                    <radio-button  text="是" value="true" name="post" v-model="needInvoice" />
                    <radio-button  text="否" value="false" name="post" v-model="needInvoice" />                
                </div>
            </div>
        </section>
        <section v-if="needInvoice === 'true'">
            <div class="section-title">
                发票信息
            </div>
            <section class="section">
                <div class="label">
                    <div class="label-title">发票抬头<span class="red">*</span></div>
                    <div class="input">
                        <input type="text" placeholder="请填写发票抬头" v-model="invoiceInfo.Title">
                    </div>
                </div>
                <div class="label">
                    <div class="label-title">税号（统一机构代码）<span class="red">*</span></div>
                    <div class="input">
                        <input type="text" placeholder="填写纳税人识别号" v-model="invoiceInfo.TaxNum">
                    </div>
                </div>
                <div class="label">
                    <div class="label-title">发票内容<span class="red">*</span></div>
                    <div class="input">
                        <input type="text" placeholder="请输入发票内容" v-model="invoiceInfo.DetailInfo">
                    </div>
                </div>
            </section>
            <div class="section-title">
                邮寄信息
            </div>
            <section class="section">
                <div class="label">
                    <div class="label-title">收件人<span class="red">*</span></div>
                    <div class="input">
                        <input type="text" placeholder="请填写收件人姓名" v-model="invoiceInfo.Name">
                    </div>
                </div>
                <div class="label">
                    <div class="label-title">联系电话<span class="red">*</span></div>
                    <div class="input">
                        <input type="number" placeholder="请填写收件人联系电话" v-model="invoiceInfo.Telephone">
                    </div>
                </div>
                <div class="label">
                    <div class="label-title">详细地址<span class="red">*</span></div>
                    <div class="input">
                        <input type="text" placeholder="请填写收件人详细地址" v-model="invoiceInfo.Address">
                    </div>
                </div>
            </section>
        </section>
         
    </section>
    
</template>

<script>
import RadioButton from '@/components/RadioButton.vue'
export default {
    name:'invoice',
    components:{
        RadioButton
    },
    props:{
        invoiceInfo:{
            type:Object,
            required: true
        }
    },
    data(){
        return {
            needInvoice: 'false'
        }
    },
    methods:{
        check(){
            this.invoiceInfo.isRequired = this.needInvoice === 'true' || this.needInvoice === true;
            if (!this.invoiceInfo.isRequired) {
                return true;
            }
            if (this.validNull(this.invoiceInfo.Title)) {
                this.$dialog.toast({
                    mes: "请填写发票抬头",
                    timeout: 1500
                });
                return false;
            } else if (this.validNull(this.invoiceInfo.TaxNum)) {
                this.$dialog.toast({
                    mes: "填写纳税人识别号",
                    timeout: 1500
                });
                return false;
            } else if (this.validNull(this.invoiceInfo.DetailInfo)) {
                this.$dialog.toast({
                    mes: "请输入发票内容",
                    timeout: 1500
                });
                return false;
            } else if (this.validNull(this.invoiceInfo.Name)) {
                this.$dialog.toast({
                    mes: "请填写收件人姓名",
                    timeout: 1500
                });
                return false;
            } else if (this.validNull(this.invoiceInfo.Telephone)) {
                this.$dialog.toast({
                    mes: "请填写收件人联系电话",
                    timeout: 1500
                });
                return false;
            } else if (this.validNull(this.invoiceInfo.Address)) {
                this.$dialog.toast({
                    mes: "请填写收件人详细地址",
                    timeout: 1500
                });
                return false;
            }   
            return true;
         
        }
    }
}
</script>
<style lang="less" scoped>
.section{
    padding: 30/@rem-size 24/@rem-size;

    .section-title {
    background: #f7f7f7;
    padding-left: 59 / @rem-size;
    line-height: 80 / @rem-size;
    font-size: 30 / @rem-size;
    color: #333;
    margin-top: 10 / @rem-size;
    position: relative;

    &::after {
      content: "";
      display: block;
      width: 0.04rem;
      height: 0.32rem;
      background: #005fd5;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 24 / @rem-size;
      margin: auto;
    }
  }
}
.label{
    margin-bottom: 20/@rem-size;
}
</style>
